export default {
    name: 'home',
    data() {
        return {
            site_name: window.APP_CONFIG.DOMAIN_NAME,
            icdn_url: window.APP_CONFIG.ICDN_URL,
            cdn_url: window.APP_CONFIG.CDN_URL,
            content: window.APP_CONFIG.LANDING_PAGE_CONTENT,
            home_color: window.APP_CONFIG.HOME_COLOR,
            m_footer_height: 0,
            open_mobile_register: false,
            is_dev: process.env.NODE_ENV !== 'production',
        }
    },
    methods: {
        gotoTop() {
            window.scrollTo(0,0)
            this.$refs['register-card'].focusInput()
        },
        handleResize() {
            if(typeof this.$refs['m-footer'] != 'undefined')
                this.m_footer_height = -Math.abs(this.$refs['m-footer'].$el.offsetHeight)
        },
        toggleMobileRegister() {
            this.open_mobile_register = !this.open_mobile_register
        },
        handleRightClick(e) {
            if (!this.is_dev) {
                e.preventDefault()
            }
        }
    },
    created() {
        if(this.$store.getters['auth/isAuthenticated']) {
            this.$router.push({
                name: 'user-home'
            })
        }
    },
    mounted() {
        this.handleResize()
        window.addEventListener("resize", this.handleResize)
        window.addEventListener("contextmenu", this.handleRightClick)
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize)
        window.removeEventListener("contextmenu", this.handleRightClick)
    },
    computed: {
        profiles() {
            let profiles = []
            if(this.$store.getters['profile/profiles'].length) {
                this.$store.getters['profile/profiles'].forEach((val, key) => {
                    if(profiles.length < 6) {
                        profiles.push(val)
                    }
                })
            }
            return profiles
        },
        homeColor() {
            return ['red','blue','purple'].indexOf(this.home_color) != -1 ? this.home_color : ''
        },
        showDesktop() {
            return this.$root.$children[0].width > 1199
        },
        midSecTitle() {
            return this.content.mid_section_title ? this.content.mid_section_title : this.$t('Find your flirt')
        },
        midSecSlogan() {
            return this.content.mid_section_slogan ? this.content.mid_section_slogan : this.$t('If you just want to flirt, make friends or even find that special one, this is the place for you!')
        },
        midSecButton() {
            return this.content.mid_section_button ? this.content.mid_section_button : this.$t('JOIN FREE')
        },
        contentLeftTitle() {
            return this.content.content_left_title ? this.content.content_left_title : this.$t('You decide what to look for')
        },
        contentLeftText() {
            return this.content.content_left_text ? this.content.content_left_text : this.$t('Chatting, meeting or making friends? Let yourself go, choose who you want and start talking. More than half of our users have a date during the first week. Good luck!')
        },
        contentLeftButton() {
            return this.content.content_left_button ? this.content.content_left_button : this.$t('Join Free')
        },
        contentRightTitle() {
            return this.content.content_right_title ? this.content.content_right_title : this.$t('Connect with people like you')
        },
        contentRightText() {
            return this.content.content_right_text ? this.content.content_right_text : this.$t('Connect with people in your city. Stop thinking about it! Join the social phenomenon of the moment. Every day thousands of people like you come together looking for all kinds of relationships.')
        },
        contentRightButton() {
            return this.content.content_right_button ? this.content.content_right_button : this.$t('Join Free')
        },
    }
}
